/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import {
  getDataCardPromises,
  loadSavedPreferences,
} from 'linced-app/utils/data-cards';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class SubjectRoute extends Route {
  // Services
  @service
  dates;

  @service
  heroApi;

  @service
  personOptions;

  @service
  session;

  @service
  store;

  model(params) {
    let store = this.store;
    let group = this.modelFor('group');
    let groupId = group.id;
    let subjectId = params.subject_id;
    let progressionType = ProgressionType.PROGRESSION;

    let { grades, subjectSummaries } = getDataCardPromises(this, {
      person: this.session.person,
      grades: true,
      summaries: true,
    });

    return hash({
      group,
      assessments: this.store.findAll('assessments/assessment'),
      modules: this.store.findAll('assessments/module'),
      gradeSchedules: this.store.findAll('assessments/grade-schedule'),
      timeframes: this.store
        .query('timeframe', { schoolId: group.get('school.id') })
        .then((timeframes) =>
          timeframes.slice().sort((a, b) => a.startDateUnix - b.startDateUnix),
        ),
      grades,
      allSubjects: store.findAll('goals/subject'),
      allLevels: store.findAll('milestones/level'),
      allExpectations: store.findAll('milestones/expectation'),
      subjectSummaries,
      subject: store.findRecord('goals/subject', subjectId),
      categories: this.store.findAll('goals/category'),
      allGoals: store.findAll('goals/goal'),
      levels: store.query('milestones/level', { goalSubjectId: subjectId }),
      expectations: store.query('milestones/expectation', {
        goalSubjectId: subjectId,
      }),
      progressions: store.query('milestones/progression', {
        goalSubjectId: subjectId,
        type: progressionType,
        groupId,
        latest: true,
      }),
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);

    let milestoneSetId = model.subject.milestone_set_id;
    let milestoneSet = { label: 'Default Milestones', isDefault: true };
    if (!isEmpty(milestoneSetId)) {
      milestoneSet = this.modelFor('group/triangulation').milestoneSets.find(
        (set) => set.id === milestoneSetId,
      );
    }
    this.controllerFor('group/triangulation').setProperties({
      currentSubjectId: model.subject.id,
      selectedMilestoneSet: milestoneSet,
    });
  }

  deactivate() {
    super.deactivate(...arguments);
    this.controllerFor('group/triangulation').set('currentSubjectId', null);
  }

  setupController(controller, model) {
    super.setupController(controller, model);

    // Load saved options from the personOptions service.
    loadSavedPreferences(controller, model, [
      'assessmentIds',
      'assessmentModuleIds',
      'subjectIds',
      'progressIds',
    ]);
  }
}
